import { Node, mergeAttributes } from '@tiptap/core';

/**
 * Custom Audio node for Tiptap. Renders an HTML5 audio element.
 */
export const Audio = Node.create({
  name: 'audio',

  group: 'block',

  atom: true,

  addAttributes() {
    return {
      src: {
        default: null,
        parseHTML: (el) => el.getAttribute('src'),
        renderHTML: (attrs) => (attrs.src ? { src: attrs.src } : {}),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'audio[src]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      { class: 'dawaer-audio-wrapper my-6' },
      ['audio', mergeAttributes({ controls: '', class: 'w-full max-w-lg' }, HTMLAttributes)],
    ];
  },
});
